import instance from "../../api";

export const getNotifications = () => {
  return instance(true)
    .get(`/crm/notice/read/`)
    .then(res => {
      return res?.data;
    })
};
export const updNotify = data => {
  return instance(true)
    .post(`/crm/notice/upd/`, data)
    .then(res => {
      return res.data;
    });
};
export const pushNotify = notice_id => {
  return instance(true)
    .post(`/crm/notice/send/${notice_id}/`)
    .then(res => {
      return res.data;
    });
};
export const delNotice = notice_id => {
  return instance(true)
    .post(`/crm/notice/del/${notice_id}/`)
    .then(res => {
      return res.data;
    });
};